/*
 *
 * EmbeddedPage actions
 *
 */

import {
  DEFAULT_ACTION,
  UPDATE_EMBEDDED_MR_OFFER_ID,
  UPDATE_EMBEDDED_OFFER_THEME,
  UPDATE_SELECTED_CHECKBOX_PRODUCTS,
  UPDATE_EMBEDDED_PRIMARY_PRODUCT,
  UPDATE_PRODUCT_ADD_ONS_WIDGET_ID,
  UPDATE_FIELD,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function updateSelectedCheckboxProducts(datapack) {
  return {
    type: UPDATE_SELECTED_CHECKBOX_PRODUCTS,
    ...datapack,
  };
}

export function updateEmbeddedOfferTheme(datapack) {
  return {
    type: UPDATE_EMBEDDED_OFFER_THEME,
    ...datapack,
  };
}

export function updateEmbeddedMrOfferID(datapack) {
  return {
    type: UPDATE_EMBEDDED_MR_OFFER_ID,
    ...datapack,
  };
}

export function updatePrimaryProduct(datapack) {
  return {
    type: UPDATE_EMBEDDED_PRIMARY_PRODUCT,
    ...datapack,
  };
}

export function updateProductAddOnsWidgetID(datapack) {
  return {
    type: UPDATE_PRODUCT_ADD_ONS_WIDGET_ID,
    ...datapack,
  };
}

export function updateField(datapack) {
  return {
    type: UPDATE_FIELD,
    ...datapack,
  };
}
